import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1200Model } from '../kymw1200.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
export type GetStaffBuyerSelectItemsResponse = {
  ClassCode: string;
  BuyerCode: string;
}[];

/**
 * 配下バイヤー選択項目取得サービス
 * @export GetStaffBuyerSelectItemsService
 * @class GetStaffBuyerSelectItemsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetStaffBuyerSelectItemsService extends PlessJsonResponderSub<GetStaffBuyerSelectItemsResponse> {
  model: KYMW1200Model;
  userId: string;
  private succeed: () => void;
  private fail: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetStaffBuyerSelectItemsService
   */
  private getBody(): PlessRequest {
    const param = {
      GroupLeaderUserId: this.userId
    };

    if (!param.GroupLeaderUserId) {
      return new PlessRequest();
    } else {
      return new PlessRequest({ parameter: param });
    }
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param f
   * @memberof GetStaffBuyerSelectItemsService
   */
  execute(
    model: KYMW1200Model,
    userId: string,
    s: () => void = null,
    f: () => void = null
  ): void {
    this.model = model;
    this.userId = userId;
    this.succeed = s;
    this.fail = f;
    this.send('getStaffBuyerSelectItems', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetStaffBuyerSelectItemsService
   */
  success(data: GetStaffBuyerSelectItemsResponse) {
    this.model.staffBuyerList = data.map((_) => {
      return {
        ClassCode: _.ClassCode,
        BuyerCode: _.BuyerCode
      }
    });
    if (this.succeed) this.succeed();
  }

  /**
   * async/await 記述用
   *
   * @param model
   * @returns Promise<void>
   */
  public executeAsync(model: KYMW1200Model, userId: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.execute(
        model,
        userId,
        () => resolve(),
        () => reject()
      );
    });
  }

  protected statusError(status: string, result: any) {
    super.statusError(status, result);
    if (this.fail) this.fail();
  }
}
